import { Component, OnInit, Output, EventEmitter, Input, HostListener } from '@angular/core';
import * as d3 from 'd3';
@Component({
    selector: 'app-heatmap-chart',
    templateUrl: './heatmap-chart.component.html'
})
export class HeatmapChartComponent implements OnInit {
    @Input() GraphData: any;
    constructor() { }
    //viewData = [];
    Xbarnumber = 5;
    currentXPage = 1;
    totalXPage: number;
    Ybarnumber = 8;
    currentYPage = 1;
    totalYPage: number;
    ngOnInit(): void {
    }
    ngAfterViewInit() {
        this.RenderHeatMapCharts(Object.assign({}, this.GraphData));
    }
    RenderHeatMapCharts(heatMapData) {
        let that = this;
        let containerId = heatMapData.chartContainerName;
        let containerIdwithoutHash = containerId.split('#')[1];
        //let divId = '#div_' + containerIdwithoutHash;
        d3.select(containerId).html("");
        //d3.select('#svg_' + containerIdwithoutHash).html("");
        //d3.select(containerId).append("div").attr('id', 'div_' + containerIdwithoutHash);
        d3.select(containerId).classed('heatmap', true);
        this.totalXPage = Math.ceil(heatMapData.xAxisCategories.length / this.Xbarnumber);
        heatMapData.xAxisCategories = heatMapData.xAxisCategories.slice((this.currentXPage - 1) * this.Xbarnumber, this.currentXPage * this.Xbarnumber);
        this.totalYPage = Math.ceil(heatMapData.yAxisCategories.length / this.Ybarnumber);
        heatMapData.yAxisCategories = heatMapData.yAxisCategories.slice((this.currentYPage - 1) * this.Ybarnumber, this.currentYPage * this.Ybarnumber);
        // if (heatMapData.chartContainerName.split("_")[1] % 2 == 0) {
        //     d3.select(heatMapData.chartContainerName).style("height", "355px");
        // }
        // else {
        //     d3.select(heatMapData.chartContainerName).style("height", "354px");
        // }   
        //document.getElementById(heatMapData.chartContainerName).innerHTML = '';
        //document.getElementById(heatMapData.chartContainerName).classList.add("heatmap");
        var chartElement = d3.select(containerId).node(); //document.getElementById(heatMapData.chartContainerName);
        var margin = { top: 20, right: 10, bottom: 50, left: 80 },
            width = chartElement.offsetWidth - margin.left - margin.right,
            height = (280) + margin.top + margin.bottom;
        //d3.select(divId).style("max-height", height + "px").style("max-width", chartElement.offsetWidth + "px").style("overflow-x", "auto").style("overflow-y", "auto");
        var h = 280 / heatMapData.yAxisCategories.length, //Math.ceil(height / (yAxisCategories[0].length + margin.top + margin.bottom)),
            w = Math.ceil(width / heatMapData.xAxisCategories.length);
        var rectHeight = 25;
        var rectWidth = 60;
        var SVGheight = (rectHeight * heatMapData.yAxisCategories.length) + 100;
        var SVGWidth = (rectWidth * heatMapData.xAxisCategories.length);
        if (this.currentXPage == 1 && this.currentYPage == 1) {
            heatMapData.chartData = heatMapData.chartData.filter(x => (x.col < heatMapData.xAxisCategories.length && x.row < heatMapData.yAxisCategories.length));
        }
        else {
            var data = [];
            // heatMapData.xAxisCategories.forEach((d, i) => {
            //     i = i + (this.currentXPage - 1) * this.Xbarnumber;
            //     data.push(heatMapData.chartData.filter(x => x.col == i));
            // });
            if (this.currentXPage == 1) {
                heatMapData.chartData = heatMapData.chartData.filter(x => (x.col < heatMapData.xAxisCategories.length));
            }
            else {
                heatMapData.chartData = heatMapData.chartData.filter(y => (y.col >= ((this.currentXPage - 1) * this.Xbarnumber) && y.col < (this.currentXPage * this.Xbarnumber)));
            }
            if (this.currentYPage == 1) {
                heatMapData.chartData = heatMapData.chartData.filter(x => (x.row < heatMapData.yAxisCategories.length));
            }
            else {
                //heatMapData.chartData = Array.prototype.concat.apply([], data);
                heatMapData.chartData = heatMapData.chartData.filter(y => (y.row >= ((this.currentYPage - 1) * this.Ybarnumber) && y.row < (this.currentYPage * this.Ybarnumber)));
            }
        }
        // if (this.currentYPage == 1) {
        //     heatMapData.chartData = heatMapData.chartData.filter(x => x.row < heatMapData.yAxisCategories.length);
        // }
        // else {
        //     var data = [];
        //     heatMapData.yAxisCategories.forEach((d, i) => {
        //         i = i + (this.currentYPage - 1) * this.Ybarnumber;
        //         data.push(heatMapData.chartData.filter(x => x.row == i));
        //     });
        //     heatMapData.chartData = Array.prototype.concat.apply([], data);
        // }
        // if (SVGWidth <= width) {
        //     this.RenderHeatMapChartsWithoutScroll(Object.assign({}, heatMapData));
        //     return;
        // }
        var colorScale = (data) => {
            if (data >= 0 && data < 10) { return '#e1ecf4'; } //hover- #ffffff
            else if (data >= 10 && data < 21) { return '#99d5fc'; } //hover- #ccffff
            else if (data >= 21 && data < 100) { return '#8cc8ea'; } //hover- #bffbff
            else if (data >= 100 && data < 500) { return '#5bb3e5'; } //hover- #8ee6ff
            else if (data >= 500 && data < 1000) { return '#51a2d1'; } //hover- #84d5ff
            else if (data >= 1000 && data < 2000) { return '#349cd8'; } //hover- #67cfff 
            else if (data >= 2000 && data < 3000) { return '#1b8ed1'; } //hover- #4ec1ff 
            else if (data >= 3000 && data < 4000) { return '#0170b4'; } //hover- #34a3e7 
            else { return '#0170bf'; } //hover- #34a3f2 
        };
        chartElement = d3.select(containerId);
        var svg = d3.select(containerId)
            //.append("div")
            .append('svg')
            .attr('id', 'svg_' + containerIdwithoutHash)
            .classed("resizableSVG", true)
            .attr('xmlns', "http://www.w3.org/2000/svg")
            .attr('viewBox', "0 0 " + (width + margin.left + margin.right) + " " + height + "")
            .attr('preserveAspectRatio', 'xMidYMid meet')
            //.classed("svg-content", true)
            .style('overflow', 'visible')
            //.attr("width", width + margin.left + margin.right)
            //.attr("height", height)
            .append("g")
            .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
      var xLine = d3.select(containerId)
        .select("svg")
        .select('g')
        .append("g")
        .attr("transform", "translate(0," + (height - (margin.top + margin.bottom)) + ")")
        .selectAll('g')
        .data(heatMapData.xAxisCategories)
        .enter()
        .append('g')
        .attr('transform', d => 'translate(' + Math.ceil((heatMapData.xAxisCategories.indexOf(d) * w) + w / 2) + ',0)')
        .append('text')
        //.attr('fill', '#015b63')
        .attr('fill', '#000')
        .style('font-size', '10px')
        .style('font-family', 'Graphik Regular')
        .style('white-space', 'nowrap')
        .style('cursor', 'default')
        .attr('y', '10')
        .attr('dy', '0.71em')
        .attr('x', '0')
        .style('text-anchor', d => {
          return 'middle';  //d.length > 8 ? 'end' : 'middle';
        })
        // .attr('transform', d => {
        //     return 'rotate(-45)';
        // })
        .text(d => {
          if (d.length > 10) {
            d = d.substring(0, 7) + '...';
          }
          return d;
        })
        .append('title')
        .text(d => d); //d.length > 13 ? d : null);

        var yLine = d3.select(containerId)
            .select("svg")
            .select('g')
            .append("g")
            .attr("transform", "translate(0,0)")
            .selectAll('g')
            .data(heatMapData.yAxisCategories)
            .enter()
            .append('g')
            .attr('transform', d => 'translate(0,' + Math.ceil((heatMapData.yAxisCategories.indexOf(d) * h) + h / 2) + ')')
            .append('text')
            .attr('y', '-3')
            .attr('dy', '0.71em')
            .attr('x', '-45')
            //.attr('fill', '#015b63')
            .attr('fill', '#000')
            .style('font-size', '10px')
            .style('font-family', 'Graphik Regular')
            .style('white-space', 'nowrap')
            .style('cursor', 'default')
            .style('text-anchor', 'middle')
            .attr('transform', d => 'rotate(0)')
            .text(d => {
                if (d.length > 12) {
                    d = d.substring(0, 10) + '...';
                }
                return d;
            })
            .append('title')
            .text(d => d.length > 12 ? d : null);
        var heatMap = d3.select(containerId)
            .select("svg")
            .select('g')
            .selectAll("rect")
            .data(heatMapData.chartData)
            .enter().append("rect")
            .attr('data-col', d => d.col)
            .attr('data-row', d => d.row)
            .attr('data-x', d => heatMapData.xAxisCategories[d.col])
            .attr('data-y', d => heatMapData.yAxisCategories[d.row])
            .attr('data-data', d => d.data)
            .attr("x", function (d) { return (d.col % that.Xbarnumber) * w; })
            .attr("y", function (d) { return (d.row % that.Ybarnumber) * h; })
            .attr("width", function (d) { return w; })
            .attr("height", function (d) { return h; })
            .attr('stroke', '#7cb5ec')
            .attr('stroke-width', 1)
            .style("fill", function (d) { return colorScale(d.data); })
        d3.selectAll('.heatmap')
            .selectAll('rect')
            .on("mouseover", function (d, i) {
                d3.select(this.closest('svg'))
                    .select('g')
                    .selectAll('rect')
                    .style("fill", function (d) { return colorScale(this.dataset.data); })
                d3.select(this)
                    .style('cursor', 'pointer')
                    .style('fill', () => {
                        var color = that.ConvertRGB2Hex(d3.select(this).style('fill'));
                        if (color == '#e1ecf4')
                            return '#ffffff';
                        else if (color == '#99d5fc')
                            return '#ccffff';
                        else if (color == '#8cc8ea')
                            return '#bffbff';
                        else if (color == '#5bb3e5')
                            return '#8ee6ff';
                        else if (color == '#51a2d1')
                            return '#84d5ff';
                        else if (color == '#1b8ed1')
                            return '#4ec1ff';
                        else if (color == '#0170b4')
                            return '#34a3e7';
                        else if (color == '#349cd8')
                            return '#67cfff';
                        else
                            return '#34a3f2';
                    });
                var tooltip = d3.select(this.closest('svg'))
                    .select('g')
                    .append("g")
                    .style("cursor", "pointer")
                    .attr("class", "tooltip")
                    .style("opacity", 1)
                tooltip.append("rect")
                    .attr("width", 90)
                    .attr('height', 50)
                    .style('fill', '#FFFFFF')
                    .style('pointer-events', 'none')
                    .style('stroke', d3.select(this).style('fill'))
                    .style('stroke-width', 2)
                    .style('fill-opacity', 0.9);
                var textSvg = tooltip.append("text")
                    .attr('x', 8)
                    .attr('y', 15)
                    .style('pointer-events', 'none')
                    .style('font-weight', 'bold')
                    .style('fill', '#333333')
                    .style('font-size', '12px')
                    .style('font-family', 'Arial')
                    .style('color', '#333333');
                textSvg.append("tspan")
                    .style('font-size', '12px')
                    .style('pointer-events', 'none')
                    .style('font-weight', 'bold')
                    .style('font-family', 'Graphik Regular')
                    .text('for ' + this.dataset.y)
                textSvg.append("tspan")
                    .attr('x', 8)
                    .attr('dy', 15)
                    .style('font-size', '12px')
                    .style('font-family', 'Graphik Regular')
                    .style('pointer-events', 'none')
                    .style('font-weight', 'bold')
                    //.style('fill', d3.select(this).style('fill'))
                    .text(heatMapData.valueType == "TicketCount" ? (d3.format(',')(parseInt(this.dataset.data)) + ' tickets in ') : ('TicketAge is ' + d3.format(',')(parseInt(this.dataset.data)) + ' days in ')) //&#9679; //&bull;
                textSvg.append("tspan")
                    .attr('x', 8)
                    .attr('dy', 15)
                    .style('pointer-events', 'none')
                    .style('font-size', '12px')
                    .style('font-family', 'Graphik Regular')
                    .text(this.dataset.x)
                    .style('font-weight', 'bold')
            })
            .on("mousemove", function (d) {
                d3.select(this).style('cursor', 'pointer');
                var mousePosition = d3.mouse(this);
                //var x = mousePosition[0];// + width / 2;
                //var y = mousePosition[1];// + height / 2;
                var x = d3.select(this).node().getAttribute('x');// + width / 2;
                var y = d3.select(this).node().getAttribute('y');// + height / 2;
                var text = d3.select(this.closest('svg')).select('g').select('.tooltip text');
                //svg.selectAll('.tooltip text tspan').nodes().forEach(element => {
                //    console.log(element.getBBox().width);
                //})
                var bbox = text.node().getBBox();
                d3.select(this.closest('svg'))
                    .select('g')
                    .select('.tooltip rect')
                    .attr("width", bbox.width + 15)
                if (x - bbox.width / 2 < 0) {
                    x = bbox.width / 2;
                }
                else if (width - x - bbox.width / 2 < 0) {
                    x = width - bbox.width / 2;
                }
                if (y - bbox.height / 2 < 0) {
                    y = bbox.height * 2;
                }
                else if (height - y - bbox.height / 2 < 0) {
                    y = height - bbox.height / 2;
                }
                d3.select(this.closest('svg'))
                    .select('g')
                    .select('.tooltip')
                    .style("opacity", 1)
                    .attr('transform', `translate(${parseInt(x) - 10}, ${parseInt(y) + 10})`);
            })
            .on("mouseout", function (d) {
                d3.select(this.closest('svg'))
                    .select('g')
                    .selectAll('rect')
                    .style("fill", function (d) { return colorScale(this.dataset.data); })
                d3.select(this.closest('svg'))
                    .select('g')
                    .select('.tooltip').style('display', 'none');
                d3.select(this.closest('svg'))
                    .select('g')
                    .select(".tooltip").remove();
                d3.select(this).selectAll('path')
                    .style("opacity", .9);
            });
        var text = d3.select(containerId)
            .select("svg")
            .select('g')
            .style('font-family', 'Graphik Regular')
            .selectAll(".textlabel")
            .data(heatMapData.chartData)
            .enter().append("text")
            .attr("class", "textlabel")
            .attr("x", function (d) { return (d.col % that.Xbarnumber) * w + (w / 2); })
            .attr("y", function (d) { return (d.row % that.Ybarnumber) * h + (h / 2) + 3; })
            .attr('text-anchor', 'middle')
            .style('font-size', '10px')
            .style('font-family', 'Graphik Regular')
            .attr("pointer-events", "none")
            //.style('font-weight', 'bold')
            .style('color', '#000000')
            .style('fill', '#000000')
        // text.append("tspan")
        //     .attr("x", function (d) { return (d.col % that.Xbarnumber) * w + (w / 2); })
        //     .attr("y", function (d) { return (d.row % that.Ybarnumber) * h + (h / 2) + 3; })
        //     .attr('stroke', '#FFFFFF')
        //     .attr('fill', '#FFFFFF')
        //     .style('font-family', 'Graphik Regular')
        //     .style('font-weight', 'bold')
        //     .attr('stroke-width', '2px')
        //     .attr('stroke-linejoin', 'round')
        //     .text(d => d.data)
        text.append("tspan")
            .attr("x", function (d) { return (d.col % that.Xbarnumber) * w + (w / 2); })
            .attr("y", function (d) { return (d.row % that.Ybarnumber) * h + (h / 2) + 3; })
            .style('font-family', 'Graphik Regular')
            .style('font-weight', 'bold')
            //.style('pointer-events', 'none')
            //.style('fill', d3.select(this).style('fill'))
            .text(d => d.data) //&#9679; //&bull;
        //d3.selectAll("rect")
        //    .on("mouseover", function () {
        //        d3.select(this).attr("opacity", .5)
        //    })
        //Pagination
        if (this.totalXPage > 1) {
            svg.append("path")
                .attr("d", "M3.875,3.095,6.8.163a.551.551,0,0,1,.782,0,.558.558,0,0,1,0,.784L4.267,4.269a.553.553,0,0,1-.763.016L.161.949A.554.554,0,0,1,.943.165Z")
                .attr('transform', "translate(" + 0 + ", " + (height - margin.bottom - margin.top + 10) + ") rotate(90)")     //19 (Because tickpadding=8 + margin from insertLineBreak=10 + 1(MagicNumber))
                .attr('class', 'leftTriangle')
                .attr('fill', '#000')
                .attr('stroke', '#000')
                .attr('stroke-width', 2)
                .attr("opacity", 0.7)
                .attr('cursor', 'pointer')
                .on('click', function (d) {
                    if (that.currentXPage != 1) {
                        that.currentXPage--;
                        that.prevPage();
                    }
                })
            svg.append("path")
                .attr("d", "M3.875,1.335,6.8,4.267a.551.551,0,0,0,.782,0,.558.558,0,0,0,0-.784L4.267.161A.553.553,0,0,0,3.5.145L.161,3.481a.554.554,0,0,0,.782.784Z")
                .attr('transform', "translate(" + (width + 7) + ", " + (height - margin.bottom - margin.top + 10) + ") rotate(90)")
                .attr('class', 'rightTriangle')
                .attr('fill', '#000')
                .attr('stroke', '#000')
                .attr('stroke-width', 2)
                .attr("opacity", 0.7)
                .style('cursor', 'pointer')
                .on('click', function (d) {
                    if (that.currentXPage < that.totalXPage) {
                        that.currentXPage++;
                        that.nextPage();
                    }
                })

            if (that.currentXPage == 1) {
                svg.select(".leftTriangle").attr('fill', '#cccccc').attr('stroke', '#cccccc').attr('stroke-width', 2).attr("opacity", 0.7).style('cursor', 'default');
            }
            if (that.currentXPage == that.totalXPage) {
                svg.select(".rightTriangle").attr('fill', '#cccccc').attr('stroke', '#cccccc').attr('stroke-width', 2).attr("opacity", 0.7).style('cursor', 'default');
            }
        }
        if (this.totalYPage > 1) {
            //var symbol = d3.symbol();
            svg.append("path")
                .attr("d", "M3.875,3.095,6.8.163a.551.551,0,0,1,.782,0,.558.558,0,0,1,0,.784L4.267,4.269a.553.553,0,0,1-.763.016L.161.949A.554.554,0,0,1,.943.165Z")
                .attr('transform', "translate(" + -10 + ", " + 0 + ") rotate(180)")
                .attr('class', 'upperTriangle')
                .attr('fill', '#000')
                .attr('stroke', '#000')
                .attr('stroke-width', 2)
                .attr("opacity", 0.7)
                .attr('stroke-width', 2)
                .attr('cursor', 'pointer')
                .on('click', function (d) {
                    if (that.currentYPage != 1) {
                        that.currentYPage--;
                        that.prevPage();
                    }
                })
            svg.append("path")
                .attr("d", "M3.875,1.335,6.8,4.267a.551.551,0,0,0,.782,0,.558.558,0,0,0,0-.784L4.267.161A.553.553,0,0,0,3.5.145L.161,3.481a.554.554,0,0,0,.782.784Z")
                .attr('transform', "translate(" + -10 + ", " + (height - margin.top - margin.bottom + 5) + ") rotate(180)")
                .attr('class', 'lowerTriangle')
                .attr('fill', '#000')
                .attr('stroke', '#000')
                .attr('stroke-width', 2)
                .attr("opacity", 0.7)
                //.attr('stroke-width', 2)
                .style('cursor', 'pointer')
                .on('click', function (d) {
                    if (that.currentYPage < that.totalYPage) {
                        that.currentYPage++;
                        that.nextPage();
                    }
                })
            if (that.currentYPage == 1) {
                svg.select(".upperTriangle").attr('fill', '#cccccc').attr('stroke', '#cccccc').attr('stroke-width', 2).attr("opacity", 0.7).style('cursor', 'default');
            }
            if (that.currentYPage == that.totalYPage) {
                svg.select(".lowerTriangle").attr('fill', '#cccccc').attr('stroke', '#cccccc').attr('stroke-width', 2).attr("opacity", 0.7).style('cursor', 'default');
            }
        }
    }
    /*generic way */
    nextPage() {
        //this.viewData = this.GraphData.chartData.slice((this.currentXPage - 1) * this.Xbarnumber, this.currentXPage * this.Xbarnumber);
        this.RenderHeatMapCharts(Object.assign({}, this.GraphData));
    }
    prevPage() {
        //this.viewData = this.GraphData.chartData.slice((this.currentXPage - 1) * this.Xbarnumber, this.currentXPage * this.Xbarnumber);
        this.RenderHeatMapCharts(Object.assign({}, this.GraphData));
    }
    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.RenderHeatMapCharts(Object.assign({}, this.GraphData));
    }
    ConvertRGB2Hex(rgb) {
        rgb = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
        return (rgb && rgb.length === 4) ? "#" +
            ("0" + parseInt(rgb[1], 10).toString(16)).slice(-2) +
            ("0" + parseInt(rgb[2], 10).toString(16)).slice(-2) +
            ("0" + parseInt(rgb[3], 10).toString(16)).slice(-2) : '';
    }
}
